// FiveImagesLayout.js

import React from "react";
import "./FiveImagesLayout.css";
import TTGImage6 from "../../assets/ttgimage6.jpg";
import TTGImage7 from "../../assets/ttgimage7.jpg";
import TTGImage8 from "../../assets/ttgimage8.jpg";
import TTGImage9 from "../../assets/ttgimage9.jpg";
import TTGImage10 from "../../assets/ttgimage10.jpg";
import TTGImage11 from "../../assets/ttgimage11.jpg";
import TTGImage16 from "../../assets/ttgimage16.jpg";

const FiveImagesLayout = () => {
  return (
    <div className="tak-till-golv-ttg-five-images-container">
      <div className="tak-till-golv-ttg-five-images-top">
        <img src={TTGImage6} alt="Image 6" className="tak-till-golv-ttg-five-image-top-left" />
        <img src={TTGImage7} alt="Image 7" className="tak-till-golv-ttg-five-image-top-right" />
      </div>
      <div className="tak-till-golv-ttg-five-images-center">
        <img src={TTGImage8} alt="Image 8" className="tak-till-golv-ttg-five-image-center" />
      </div>
      <div className="tak-till-golv-ttg-five-images-bottom">
        <img src={TTGImage9} alt="Image 9" className="tak-till-golv-ttg-five-image-bottom-left" />
        <img src={TTGImage10} alt="Image 10" className="tak-till-golv-ttg-five-image-bottom-right" />
      </div>
      <div className="tak-till-golv-ttg-five-images-center">
        <img src={TTGImage11} alt="Image 8" className="tak-till-golv-ttg-five-image-center" />
      </div> 

      <div className="center-video-container-text">Tak Till Golv - Din Byggpartner - Kvalitet och Omsorg i Varje Projekt</div>

    </div>
  );
};

export default FiveImagesLayout;
